import { Col, Form, Row } from "react-bootstrap";
import { HeaderRegister } from "../../components/HeaderRegister";
import { GroupService } from "../../services/group.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import * as yup from 'yup';
import { GroupModel } from "../../models/group.model";
import { BranchModel } from "../../models/branch.model";
import BranchService from "../../services/branch.service";
import storageService from "../../services/storage.service";

const GroupRegister = () => {
    const user = storageService.getUser();
    const [branchList, setBranchList] = useState<BranchModel[]>([]);
    const { id } = useParams<{ id?: string }>();
    const [initialValues, setInitialValues] = useState<GroupModel>({
        id: 0,
        fullName: '',
        nickName: '',
        selectedBranchIdList: [],
        inconsistentForecastAnalysis:false,
    });
    const [isLoading, setLoading] = useState(false);
    const { t } = useTranslation();
    const formRef = useRef();
    const history = useHistory();
    const onSubmit = async (data) => {
        if (Number(id)) {
            await update(data);
        } else {
            await create(data);
        }
    };
    const create = async (data) => {               
        try {
            const response: any = await GroupService.insert(data);
            if (response.success) {
                ToastService.success(t('GROUP.INSERTED'));
                history.push(`/Group`);
            }
        } catch (error) {
            console.log(error);
            ToastService.error(t('ERROR_GENERIC'));
        }
    };
    const update = async (data) => {
        try {
            data.id = Number(id);
            const response: any = await GroupService.update(data);
            if (response.success) {
                ToastService.success(t('GROUP.UPDATED'));
                history.push(`/Group`);
            }
        } catch (error) {
            console.log(error);
            ToastService.error(t('ERROR_GENERIC'));
        }
    };

    const initialize = async () => {
        const responseBranch: any = await BranchService.getAllListForDropdown();

        if (responseBranch && responseBranch.result) {
            setBranchList(responseBranch.result);
        }

        if (Number(id)) {
            const response: any = await GroupService.getById(id);
            try {
                if (response) {
                    if (response.result) {
                        setInitialValues(response.result);
                    }
                }
            } catch (error) {
                ToastService.error(t('ERROR_GENERIC'));
            }
        }
    };
    useEffect(() => {
        initialize();
    }, []);
    const schema = yup.object().shape({
        fullName: yup.string().required(t('REQUIRED')),
        nickName: yup.string().required(t('REQUIRED'))
    });
    const submitFormik = () => {
        if (formRef && formRef.current) {
            let current: any = formRef.current;
            current.handleSubmit();
        }
    }
  
    return (
        <>
            {/* {JSON.stringify(branchList, null, 2)} */}
            <HeaderRegister title={`${t('GROUP.TITLE')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`} path={"/Group"} submitForm={submitFormik} isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}/>
            <Formik
                enableReinitialize={true}
                innerRef={formRef}
                initialValues={initialValues}
                validationSchema={schema}
                onSubmit={(values, actions) => {
                    onSubmit(values);
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row>
                            {/* {JSON.stringify(values)}
                            {JSON.stringify(errors)} */}
                            <Col xs={12} xl={12}>
                                <Row className="align-items-center">
                                    <Col sm={12} md={6} lg={3} className="mb-4">
                                        <Form.Group>
                                            <Form.Floating>
                                                <Form.Control
                                                    name='fullName'
                                                    id='fullName'
                                                    type='text'
                                                    placeholder={t('GROUP.FULLNAME')}
                                                    maxLength={100}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={isLoading}
                                                    isInvalid={touched.fullName && !!errors.fullName}
                                                    value={values.fullName}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.fullName}
                                                </Form.Control.Feedback>
                                                <Form.Label>{t('GROUP.FULLNAME')}</Form.Label>
                                            </Form.Floating>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} md={6} lg={3} className="mb-4">
                                        <Form.Group>
                                            <Form.Floating>
                                                <Form.Control
                                                    name='nickName'
                                                    id='nickName'
                                                    type='text'
                                                    placeholder={t('GROUP.NICKNAME')}
                                                    maxLength={6}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={isLoading}
                                                    isInvalid={touched.nickName && !!errors.nickName}
                                                    value={values.nickName}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.nickName}
                                                </Form.Control.Feedback>
                                                <Form.Label>{t('GROUP.NICKNAME')}</Form.Label>
                                            </Form.Floating>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} md={6} lg={3} className="mb-4">
                                        <Form.Group>
                                            <Form.Floating>
                                                <Form.Check
                                                    name='inconsistentForecastAnalysis'
                                                    id='inconsistentForecastAnalysis'
                                                    label={t('GROUP.INCONSISTENT_FORECAST_ANALYSIS')}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={isLoading}
                                                    checked={values.inconsistentForecastAnalysis}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.inconsistentForecastAnalysis}
                                                </Form.Control.Feedback>
                                            </Form.Floating>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} xl={12}>
                                <Row className="align-items-center">
                                    <Col sm={12} md={6} lg={3} className="mb-4">
                                        {t('BRANCH.TITLE_LIST')}
                                        <FieldArray
                                            name="selectedBranchIdList"
                                            render={arrayHelpers => (
                                                <>
                                                    {branchList.map((branch, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <Form.Check type="checkbox" label={branch.fullName}
                                                                    name={'selectedBranchIdList'}
                                                                    checked={values.selectedBranchIdList.includes(branch.id)}
                                                                    onChange={e => {
                                                                        if (e.target.checked) {
                                                                            arrayHelpers.push(branch.id);
                                                                        } else {
                                                                            const idx = values.selectedBranchIdList.indexOf(branch.id);
                                                                            arrayHelpers.remove(idx);
                                                                        }
                                                                    }}
                                                                />
                                                            </div>)
                                                    })} </>)} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </>
    );
};
export default GroupRegister;